'use client'
import { useMemoizedContentGetter } from 'utils/contentful'
import { PaperCarousel } from 'components/Carousels/PaperCarousel'

function MoreResourcesCarousel({ content }) {
  let memoizedContent = useMemoizedContentGetter(content, [
    'title',
    'carousel',
    'theme',
    'eyebrow',
    'config',
  ])
  const {
    title,
    theme,
    eyebrow,
    carousel: { carouselItemsCollection },
    config,
  } = memoizedContent
  const variationDot = config?.jsonContent?.variationDot ?? null
  return (
    <PaperCarousel
      title={title}
      carouselItems={carouselItemsCollection?.items}
      theme={theme}
      idPrefix="home"
      titleTag="h3"
      eyebrow={eyebrow}
      listNameTracking={config?.jsonContent?.listNameTracking}
      fetchPriority="high"
      preload={config?.jsonContent?.priority}
      variationDot={variationDot}
    />
  )
}
export { MoreResourcesCarousel }
export default MoreResourcesCarousel
